"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("../utils/styles");
exports.Separator = function () { return react_1.default.createElement("div", { className: styles_1.styles.separator }); };
//# sourceMappingURL=Separator.js.map